module.exports = __webpack_public_path__ + "static/media/r395.55c5f274.jpg";